var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.container},[(_vm.description)?_c('v-read-more',{attrs:{"size":"md","content":_vm.description,"name":"more"}}):_c('v-no-data',{attrs:{"size":"sm"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }